import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Observable } from 'rxjs';
import { URL_SERVICIOS_SOCKET } from '../config/config';
import { ENVIRONMENT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class SocketLogService {
  private socket: Socket;

  constructor() {
    this.socket = io(URL_SERVICIOS_SOCKET, {
        transports: ['websocket'],
        withCredentials: true
      });

    this.socket.on('connect', () => {
      // console.log('✅ Conectado a socket logs, url socket:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT);
    });

    this.socket.on('connect_error', (err) => {
      console.error('❌ Error de conexión socket logs:', err, 'url socket:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT);
    });
  }

  // Observable para recibir logs en tiempo real
  onLog(type: 'onDemand' | 'apiAvanti' | 'sockets' | 'wsp' | 'mailing' | 'carga' | 'tbk' | 'middlewares'): Observable<string> {
    return new Observable<string>((observer) => {
      this.socket.on(`logs:${type}`, (data: string[] | string) => {
        if (Array.isArray(data)) {
          data.forEach(line => observer.next(line));
        } else {
          observer.next(data);
        }
      });

      return () => this.socket.off(`logs:${type}`);
    });
  }


  disconnect(): void {
    this.socket.disconnect();
  }
}
